import { createFileRoute, redirect } from "@tanstack/react-router"

/** Legacy bookmarks — resume onboarding is the single profile setup path. */
export const Route = createFileRoute("/candidate/profile")({
  beforeLoad: () => {
    throw redirect({ to: "/onboarding/candidate" })
  },
  component: () => null,
})
